import { render, staticRenderFns } from "./holiday-table.vue?vue&type=template&id=2c6a0742&scoped=true"
import script from "./holiday-table.vue?vue&type=script&lang=js"
export * from "./holiday-table.vue?vue&type=script&lang=js"
import style0 from "./holiday-table.vue?vue&type=style&index=0&id=2c6a0742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a0742",
  null
  
)

export default component.exports